import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { IoArrowForward, IoPawOutline, IoQrCode } from "react-icons/io5";
import { RiFileSearchLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useAuth } from "store/hooks/useAuth";
import { enabledModulesAccess } from "utils/modules-access";
import { getFullPathEnv } from "utils/pathEnv";

export const MenuList = () => {
  const usuario = useAuth();
  const navigate = useNavigate();

  function redirectLogin(to: string, routePublic = false) {
    if (usuario || routePublic) {
      navigate(to);
      return;
    }
    window.location.href = `${getFullPathEnv(
      "REACT_APP_IDENTITY_URL",
      `login?callbackUrl=${window.location.origin}${to}`
    )}`;
  }

  const menuServicos = [
    {
      titulo: "Meus animais",
      icon: IoPawOutline,
      to: "/zoonose",
      disabled: !enabledModulesAccess(["ZOONOSE"]),
      public: false
    },
    {
      titulo: "Validar Documento",
      icon: IoQrCode,
      to: "/servicos/validador",
      disabled: !enabledModulesAccess(["VALIDAR_DOCUMENTO"]),
      public: true
    },
    {
      titulo: "Consulta prévia",
      icon: RiFileSearchLine,
      to: "/consulta-previa",
      disabled: !enabledModulesAccess(["LICENCIAMENTO_URBANO"]),
      public: false
    },
    {
      titulo: "Ouvidoria",
      icon: RiFileSearchLine,
      to: "/ouvidoria",
      disabled: !enabledModulesAccess(["OUVIDORIA"]),
      public: false
    }
  ];

  return (
    <HStack>
      {menuServicos
        .filter((x) => !x.disabled)
        .map((s) => (
          <Box
            key={s.titulo}
            p={3}
            borderRadius="md"
            bgColor="#ED8936"
            boxShadow="sm"
            w={{ base: "150px", sm: "170px" }}
            cursor="pointer"
            _hover={{ bgColor: "#DD6B20", transition: "0.2s", fontWeight: 500 }}
            onClick={() => redirectLogin(s.to, s.public)}
          >
            <HStack justifyContent="space-between" alignItems="flex-start">
              <VStack
                bgColor="white"
                borderRadius="full"
                w="3rem"
                h="3rem"
                p={2}
                alignItems="center"
                justifyContent="center"
              >
                <s.icon color="#DD6B20" size={20} />
              </VStack>
              <IoArrowForward color="white" size={15} />
            </HStack>
            <Text
              mt="2"
              fontWeight={400}
              fontSize="sm"
              color="white"
              _groupHover={{ fontWeight: 700 }}
            >
              {s.titulo}
            </Text>
          </Box>
        ))}
    </HStack>
  );
};
